import PropTypes from 'prop-types'
import { useState } from 'react'
import { Progress, message } from 'antd'
import { createUseStyles } from 'react-jss'
import useInterval from '../../hooks/useInterval'
import { getBatchSignatureStatus } from '../../api/reports'

const REFETCHING_TIME = 2000

const useStyles = createUseStyles({
  container: {
    position: 'fixed',
    bottom: '4px',
    left: '0px',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    zIndex: 1000,
  },
  box: {
    background: '#1C1C1C',
    padding: '20px 40px',
    width: '400px',
    borderRadius: '4px',
    boxShadow: '0 2px 8px rgb(28 28 28 / 75%)',
  },
  label: {
    lineHeight: '0.75',
    color: 'white',
    fontSize: '13px',
    marginBottom: '12px',
  },
})

export default function BatchSignProgress({ batchId, onComplete }) {
  const [progress, setProgress] = useState(0)
  const [status, setStatus] = useState('loading')
  const classes = useStyles()

  const checkProgress = async () => {
    try {
      const data = await getBatchSignatureStatus(batchId)

      if (data.error) {
        message.error(`Error regenerating PDFs: ${data.error}`)
        setStatus('error')
        return
      }

      const percentage = Math.round(
        (data.processedFiles / data.totalFiles) * 100,
      )
      setProgress(percentage)

      if (data.finishedAt) {
        setStatus('finished')
        setTimeout(() => {
          onComplete()
        }, 3000)
      }
    } catch (e) {
      setStatus('error')
      message.error('Error checking signature progress')
    }
  }

  useInterval(checkProgress, status === 'loading' ? REFETCHING_TIME : null)

  const getStatusType = currentStatus => {
    if (currentStatus === 'error') return 'exception'
    if (currentStatus === 'finished') return 'success'
    return 'active'
  }

  return (
    <div className={classes.container}>
      <div className={classes.box}>
        <div className={classes.label}>
          {status === 'loading' && 'Regenerating signed PDFs...'}
          {status === 'finished' && 'PDFs have been regenerated'}
          {status === 'error' && 'Error regenerating PDFs'}
        </div>
        <Progress percent={progress} status={getStatusType(status)} />
      </div>
    </div>
  )
}

BatchSignProgress.propTypes = {
  batchId: PropTypes.string.isRequired,
  onComplete: PropTypes.func.isRequired,
}
